import { render, staticRenderFns } from "./extractTermList.vue?vue&type=template&id=7f8c4e4b"
import script from "./extractTermList.vue?vue&type=script&lang=js"
export * from "./extractTermList.vue?vue&type=script&lang=js"
import style0 from "./extractTermList.vue?vue&type=style&index=0&id=7f8c4e4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports